import React from 'react'

export default (props) => {
  const {
    invertWhenValid,
    value,
    onChange,
    placeholder,
    errorMessage,
    name,
    onBlur,
    isValid,
    idName,
    disabled,
    label,
    allowAutoComplete = false,
  } = props;

  return (
    <>
      <div className='numberplate-input-parent-wrapper'>
        {label && <p className='numberplate-input-label'>{label}</p>}
        <div
          className={`
          numberplate-input-wrapper
          ${invertWhenValid ? 'invert-when-valid' : ''}
          ${disabled ? 'numberplate-input-wrapper--is-disabled' : ''}
          ${(isValid || disabled) ? 'numberplate-input-wrapper--is-valid' : errorMessage ? 'numberplate-input-wrapper--is-invalid' : ''}
        `}>
          <div className='numberplate-input'>
            <input
              className={'sessioncamhidetext text-input text-input--is-numberplate-input'}
              type="text"
              name={name}
              value={value}
              onChange={onChange}
              onBlur={() => {
                onBlur && onBlur()
              }}
              placeholder={placeholder}
              id={idName ?? ''}
              disabled={disabled}
              autocomplete={allowAutoComplete ? 'on' : 'off'}
            />
            <span className='numberplate-input-icon'></span>
          </div>
        </div>
      </div>
      {(!isValid && !disabled) && <p className="form-input-error-message">{errorMessage}</p>}
    </>
  )
}
